import { z } from 'zod';
const wnlMessage = { message: 'Mark as within normal limits if none applies', path: [] };
export const basePsychosocialSchema = z.object({
    wnl: z.boolean().optional(),
    status: z.array(z.string()).optional(),
});
export const basePsychosocialSchemaRefined = z
    .object({
    wnl: z.boolean().optional(),
    status: z.array(z.string()).optional(),
})
    .refine((data) => data.wnl || data.status?.length, wnlMessage);
